import React from 'react';
import { Link } from 'react-router-dom';
import SimpleMenu from './simple-menu.component';

const HeaderStrip = () => (
   <div className="flex justify-between bg-black w-full">
      <Link to="/"><span className="text-white text-2xl">Ethan David Loch</span></Link>
      <SimpleMenu />
   </div>
);

export default HeaderStrip;